import axios, { axiosExternalPlugin } from '@/lib/axios'

/**
 * Generic GET request with optional query params
 * @param {string} url - API endpoint
 * @param {object} [params] - Query parameters (optional)
 */
export async function getData(url: string, params?: object) {
  const response = await axios.get(url, { params })
  return response.data.data
}

/**
 * Generic GET request to external API
 * @param {string} url - API endpoint
 */
export async function getExternalData(url: string) {
  const response = await axiosExternalPlugin.get(url)
  return response.data
}

/**
 * Generic POST request
 * @param {string} url - API endpoint
 * @param {object} data - Request body
 */
export async function postData(url: string, data: object) {
  const response = await axios.post(url, data)
  return response.data.data
}

/**
 * Generic post as multipart/form-data
 * @param {string} url - API endpoint
 * @param {object} data - Posting data as multipart/form-data
 */
export async function postForm(url: string, data: object) {
  const response = await axios.postForm(url, data)
  return response.data.data
}

/**
 * Generic PATCH request (for updating data)
 * @param {string} url - API endpoint
 * @param {object} data - Request body
 */
export async function patchData(url: string, data: object) {
  const response = await axios.patch(url, data)
  return response.data.data
}

/**
 * Generic DELETE request
 * @param {string} url - API endpoint
 */
export async function deleteData(url: string) {
  const response = await axios.delete(url)
  return response.data.data
}

/**
 * Download file as blob (for ZIP downloads)
 * @param {string} url - API endpoint
 */
export async function downloadBlob(url: string) {
  const response = await axios.get(url, {
    responseType: 'blob',
  })
  return response.data
}

